import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const logoutIcon = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6" stroke="#CF4452" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10.6667 11.3333L14 8L10.6667 4.66667" stroke="#CF4452" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 8H6" stroke="#CF4452" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
);
